import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./Components/Header";
import Homepage from "./Components/Homepage";
import About from "./Pages/About";
import ServicesSection from "./Pages/Services";
import Footer from "./Components/Footer";
import ContactSection from "./Pages/ContactUs";
import ClientSection from "./Pages/Clients";
import Portfolio from "./Pages/Portfolio";
import BackToTop from "./Components/BacktoTop";
import VisionPage from "./Pages/VisionPage";
import TeamShowcase from "./Pages/Teamshowcase";

const App = () => {
  useEffect(() => {
    const defaultTitle = "GGM-Glowingrowth Media";
    const awayTitle = "😘 Missing You 3000";

    // Set the default title initially
    document.title = defaultTitle;

    const handleVisibilityChange = () => {
      if (document.hidden) {
        document.title = awayTitle;
      } else {
        document.title = defaultTitle;
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<ServicesSection />} />
        <Route path="/contact-us" element={<ContactSection />} />
        <Route path="/clients" element={<ClientSection />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/vision" element={<VisionPage />} />
        <Route path="/our-team" element={<TeamShowcase />} />
      </Routes>
      <BackToTop />
      <Footer />
    </Router>
  );
};

export default App;
